export const connectionDual = (data) => {
    return {
        type: 'CONNECTION_DUAL',
        data,
    };
};
